import React from 'react';
import './Contact.css'
import { GoLocation } from "react-icons/go";
import { TfiTimer } from "react-icons/tfi";
import { AiOutlineMobile } from "react-icons/ai";
import { CiMail } from "react-icons/ci";
import { IoMdCall } from "react-icons/io";
import { BsCart2 } from "react-icons/bs";

const Contact = () => {
    return (
        <div className='py-12'>
           <div className="contact-main">
            <div className="contact-infoo">
                <div className="flex one">                 
                    <h5><GoLocation /></h5>
                    <p className='mx-5 '> <span>Men's Fashion</span>  <br />
                     Ha Noi, VIet Nam. <br />
                     Ha Noi, California 100000 <br />
                     United States</p>
                </div>
                <div className="flex py-6 one">
                    <h5><IoMdCall /></h5>
                    <p className='mx-5'> <span>Call us:</span>  <br />
                      45643165651556 </p>
                </div>
                <div className="flex one">
                    <h5><CiMail /></h5>
                    <p className='mx-5'><span> Email us:</span> <br />
                     demo@demo.com</p>
                </div>
               
               
            </div>
            <div className="contact-form">
                 <h1 className=' m-8 text-3xl'>Contact Us</h1>
                <div className="formm">             
                <form >
                    <label>Subject</label> <br />
                    <input type="text" /> <br />
                    <label>Email </label> <br />
                    <input type="email" /> <br />
                    <label>Message</label> <br />
                    <textarea placeholder=' How can we help?' name="" id="" ></textarea>                                                         </form>
               <button className='btn '>Send</button> 
               </div>
            </div>
           </div>
        </div>
    );
};

export default Contact;